export default "__VITE_ASSET__b2901a56__"